import React from 'react'

import Reflux from 'reflux-react-16'
import moment from 'moment'
import aSync from 'async'
import _ from 'underscore'
import JSZip from 'jszip'
const zip = new JSZip()
import FileSaver from 'file-saver'

import CustomerStore from '../../stores/CustomerStore.js'
import InvoiceStore from '../../stores/InvoiceStore.js'
import InvoiceActions from '../../actions/InvoiceActions.js'

import InvoiceModal from '../../components/invoices/InvoiceModal.js'
import Table from '../../components/UI/table/index.js'
import SearchBar from '../../components/SearchBar/index.js'
import {Button, Colors, IconButton, P, Panel, Popup} from '../../components/UI/index.js'
import filter, {invoiceDebtorCode} from '../../utils/filter.js'
import csvExport from '../../utils/csvExport.js'
import ExportInvoicesModal from '../../components/invoices/ExportInvoicesModal.js'
import Languages from '@utils/Languages.js'
import t from 'src/helpers/Languages.js'
import branchesAvailable from '@utils/branchesAvailable.js'
import {formSpacing} from '../../components/UI/forms/index.js'
import createMemo from '../../utils/createMemo.js'

class Invoices extends Reflux.Component {
    constructor(props) {
        super(props)

        this.columnsMemo = createMemo()

        this.stores = [InvoiceStore, CustomerStore]
    }

    componentDidMount() {
        const {reseller} = this.props

        InvoiceActions.get(true)

        if (this.props.location?.state?.invoiceId) {
            this.onClickViewInvoice(this.props.location?.state?.invoiceId)
        }

        document.title = `Facturatie • ${reseller.settings.accountName || reseller.name}`

        window.history.replaceState({}, '')
    }

    // The same columns until a value they read changes: new columns re-render every row of the table
    columns() {
        return this.columnsMemo([this.props.reseller, this.state.customers], () => this.buildColumns())
    }

    buildColumns() {
        const {reseller} = this.props

        return [
            ...branchesAvailable(reseller) ?
                [{id: 'branchName', title: t('branch'), visible: false, key: 'branchName', width: 180, text: (invoice) => {
                    const branch = reseller.settings.branches?.find((branch) => branch.id === invoice?.branchId)
                    return branch?.name || ''
                }}] :
                [],
            {id: 'date', title: 'Datum', visible: true, width: 120, key: 'date', text: (invoice) => {
                return invoice.invoiced ? moment(invoice.date).format('DD-MM-YYYY') : ''
            }, sort: (invoice) => invoice.invoiced ? invoice.date : ''},
            {id: 'invoiceNumber', title: 'Factuurnummer', visible: true, width: 200, key: 'invoiceNumber'},
            {id: 'customer', title: 'Klant', visible: true, flex: 1, key: 'customer', sort: (invoice) => {
                return this.state.customers[invoice.customer] ? this.state.customers[invoice.customer].name : ''
            }, text: (invoice) => {
                return this.state.customers[invoice.customer] ? this.state.customers[invoice.customer].name : ''
            }},
            {id: 'debtorCode', title: 'Debiteurnummer', visible: false, width: 150, key: 'debtorCode', text: (invoice) => {
                return invoiceDebtorCode(this.state.customers[invoice.customer])
            }},
            {id: 'description', title: 'Omschrijving', visible: true, flex: 1, key: 'description'},
            {id: 'price', title: 'Totaal', visible: true, width: 120, key: 'price', text: (invoice) => {
                return `€ ${invoice.price}`
            }},
            {id: 'notes', title: 'Notities', visible: true, flex: 1, key: 'notes'},
            {id: 'status', title: Languages.status['NL'], visible: true, flex: 1, key: 'status', render: (invoice) => {
                return (
                    <P ellipsis style={{width: '100%', padding: 5, textAlign: 'center', background: invoice.invoiced ? Colors.completed : Colors.expected, borderRadius: 4}}>{invoice.invoiced ? 'Gefactureerd' : 'Concept'}</P>
                )
            }, sort: (invoice) => invoice.invoiced ? 'Gefactureerd' : 'Concept'},
            {id: 'view', visible: true, showOnHover: true, width: 50, render: (invoice) => {
                return (
                    <IconButton onClick={this.onClickViewInvoice.bind(this, invoice.invoiced ? invoice._id : invoice)}>
                        <i className='mdi mdi-eye' />
                    </IconButton>
                )
            }}
        ]
    }

    onChangeDates(startDate, endDate) {
        InvoiceActions.setDates(startDate, endDate)
    }

    onChangeQueries(invoiceQueries) {
        this.table.selectPage(1)
        InvoiceActions.setQueries(invoiceQueries)
    }

    onChangeTable(selectedInvoices) {
        InvoiceActions.setSelected(selectedInvoices)
    }

    onClickViewInvoice(id) {
        this.modal.open(id)
    }

    onClickSendInvoice() {
        const {reseller} = this.props
        const {selectedInvoices, customers} = this.state

        const invoices = _.filter(this.state.invoices, (invoice) => {
            return !invoice.invoiced && selectedInvoices.indexOf(invoice._id) > -1
        })

        this.popup.open('Facturen aanmaken', `Facturen worden aangemaakt${reseller.settings.administration.api ? ' en verstuurd naar het gekoppelde boekhoudsysteem' : ''}, hierna kunnen ze worden gedownload.`, () => {
            let success = 0
            const errors = []
            InvoiceActions.setSelected([])

            this.popup.setProgress(0, invoices.length)

            aSync.eachSeries(invoices, (invoice, next) => {
                InvoiceActions.send(invoice, (err) => {
                    if (err) {
                        const customer = _.findWhere(customers, {_id: invoice.customer})
                        errors.push(`${customer ? customer.name : invoice.customer} | ${err}`)
                    } else {
                        success += 1
                    }
                    this.popup.setProgress(success + errors.length, invoices.length)

                    next()
                })
            }, () => {
                this.popup.setMessage(`${success} ${success === 1 ? 'factuur' : 'facturen'} aangemaakt.`)
                this.popup.setErrors(errors)
                InvoiceActions.get(true)
            })
        })
    }

    onClickRemoveInvoice() {
        const {selectedInvoices} = this.state
        const {reseller} = this.props

        const invoices = _.filter(this.state.invoices, (invoice) => {
            return invoice.invoiced && selectedInvoices.indexOf(invoice._id) > -1
        })

        this.popup.open('Facturen verwijderen', `Verwijderde facturen worden weer zichtbaar als concept en kunnen opnieuw worden aangemaakt. ${reseller.settings.administration.api ? `Facturen worden niet verwijderd in ${reseller.settings.administration.api}` : ''}`, () => {
            InvoiceActions.setSelected([])

            aSync.eachSeries(invoices, (invoice, next) => {
                InvoiceActions.remove(invoice._id, (err) => {
                    if (err) {
                        this.popup.setError(err)
                    } else {
                        next()
                    }
                })
            }, () => {
                this.popup.close()
            })
        })
    }

    async onClickExport(template, onProgress) {
        const {invoices, selectedInvoices, startDate, endDate, customers} = this.state
        const exportInvoices = []
        const invoicesById = _.indexBy(invoices, '_id')

        selectedInvoices.map((id) => {
            const invoice = invoicesById[id]

            if (invoice) {
                exportInvoices.push(invoice)
            }
        })

        await csvExport.invoices(exportInvoices, startDate, endDate, customers, template, onProgress)
        InvoiceActions.setSelected([])
        this.setState({exportInvoicesIsOpen: false})
    }

    onClickXMLExport() {
        const {selectedInvoices} = this.state

        this.setState({exportLoading: true})
        InvoiceActions.XMLExport(selectedInvoices, (err, response) => {
            if (err) {
                this.popup.open('Foutmelding', '', () => {})
                this.popup.setError(err)
            } else {
                if (response.errors.length) {
                    this.popup.open('Foutmeldingen', '', () => {})
                    this.popup.setErrors(response.errors)
                }
                const blob = new Blob([response.xml], {type: 'data:application/xml,charset=utf-8'})
                FileSaver.saveAs(blob, 'Administratie_export.xml')
            }

            this.setState({exportLoading: false})
        })
    }

    onClickDownloadAttachment() {
        const {selectedInvoices, invoices} = this.state

        const selected = _.filter(invoices, (invoice) => {
            return selectedInvoices.indexOf(invoice._id) > -1 && invoice.invoiced
        })

        if (selected.length) {
            this.setState({pdfLoading: true})

            const responses = []
            const usedCustomers = {}

            aSync.eachSeries(selected, (invoice, next) => {
                InvoiceActions.toPDF(invoice, (err, response) => {
                    if (!err) {
                        responses.push(response)
                    }
                    next()
                })
            }, () => {
                responses.map((response) => {
                    usedCustomers[response.customer] = usedCustomers[response.customer] || 0
                    const count = usedCustomers[response.customer]

                    zip.file(`${response.customer}${count > 0 ? `(${count})` : ''}.pdf`, response.pdf, {base64: true})

                    usedCustomers[response.customer] += 1
                })

                zip.generateAsync({type: 'base64'}).then((base64) => {
                    this.setState({pdfLoading: false})
                    window.location = `data:application/zip;base64,${base64}`
                })
            })
        }
    }

    render() {
        const {selectedInvoices, invoicesLoading, startDate, endDate, invoiceQueries, pdfLoading, exportLoading, customers, exportInvoicesIsOpen} = this.state
        const {history, reseller, onUpdateReseller} = this.props
        const invoices = filter.invoices(this.state.invoices || [], invoiceQueries, reseller)

        return (
            <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                <Panel style={{display: 'flex', columnGap: formSpacing.columnGap, borderTop: 'none', borderLeft: 'none', borderRight: 'none', background: Colors.backgroundNeutral, padding: '20px 10px 10px 10px'}}>

                    <SearchBar
                        columns={this.columns()}
                        onQueryChange={this.onChangeQueries.bind(this)}
                        onDateChange={this.onChangeDates.bind(this)}
                        startDate={startDate}
                        endDate={endDate}
                        queries={invoiceQueries}
                    />

                    {selectedInvoices.length > 0 &&
                        <>
                            <Button
                                variant='outline-white'
                                onClick={this.onClickSendInvoice.bind(this, null)}
                            >
                                Facturen aanmaken
                            </Button>

                            <Button
                                variant='outline-white'
                                loading={pdfLoading}
                                onClick={this.onClickDownloadAttachment.bind(this, null)}
                                tooltip='Factuur bijlages downloaden'
                            >
                                <i className='mdi mdi-download' />
                            </Button>

                            {reseller.settings.administration.xmlExport &&
                                <Button
                                    variant='outline-white'
                                    loading={exportLoading}
                                    onClick={this.onClickXMLExport.bind(this, null)}
                                    tooltip='Exporteer facturen in XML'
                                >
                                    <i className='mdi mdi-xml' />
                                </Button>
                            }

                            <Button
                                variant='outline-white'
                                onClick={() => this.setState({exportInvoicesIsOpen: true})}
                                tooltip={reseller.settings.administration.xmlExport ? 'Exporteer facturen in CSV' : 'Facturen exporteren'}
                            >
                                <i className='mdi mdi-file-export' />
                            </Button>

                            <Button
                                variant='outline-white'
                                onClick={this.onClickRemoveInvoice.bind(this)}
                            >
                                <i className='mdi mdi-delete' />
                            </Button>
                        </>
                    }
                </Panel>

                <div style={{flex: 1, marginTop: 24, marginRight: 24, marginLeft: 24}}>
                    <Table
                        tableName='invoices'
                        columns={this.columns()}
                        rows={invoices}
                        selectedRows={selectedInvoices}
                        loading={invoicesLoading}
                        onChange={this.onChangeTable.bind(this)}
                        ref={(ref) => this.table = ref}
                    />
                </div>

                <InvoiceModal
                    history={history}
                    reseller={reseller}
                    customers={customers}
                    ref={(modal) => this.modal = modal}
                />
                <Popup ref={(ref) => this.popup = ref} />

                <ExportInvoicesModal
                    reseller={reseller}
                    onChange={onUpdateReseller}
                    onClickExport={this.onClickExport.bind(this)}
                    open={exportInvoicesIsOpen}
                    onClose={() => this.setState({exportInvoicesIsOpen: false})}
                />
            </div>
        )
    }
}

export default Invoices
